import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GardenViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GardenViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5271 19.4284H20.4078V18.5025H21.0235C21.2782 18.5025 21.4856 18.2951 21.4856 18.0404V16.1138C21.4856 15.8591 21.2782 15.6517 21.0235 15.6517H19.9253V14.8672H20.6362C20.8909 14.8672 21.0983 14.6598 21.0983 14.4051V12.4785C21.0983 12.2238 20.8909 12.0165 20.6362 12.0165H19.9253V11.722C19.9253 11.4673 19.7179 11.26 19.4632 11.26C19.2085 11.26 19.0011 11.4673 19.0011 11.722V12.0165H13.8208V11.722C13.8208 11.4673 13.6134 11.26 13.3587 11.26C13.104 11.26 12.8966 11.4673 12.8966 11.722V12.0165H12.5998C12.5899 11.2296 12.3107 10.4702 11.81 9.86906C11.9648 9.51097 12.046 9.11724 12.046 8.72701C12.046 7.14217 10.7562 5.85233 9.17136 5.85233C8.62166 5.85233 8.09416 6.0048 7.63675 6.29396C7.54971 4.82244 6.31653 3.64652 4.82691 3.64652C3.2742 3.64652 2.01123 4.90949 2.01123 6.46162V12.3944C2.01123 13.7655 3.01833 14.9478 4.36484 15.1715V19.4284H2.47331C2.21861 19.4284 2.01123 19.6357 2.01123 19.8904C2.01123 20.1451 2.21861 20.3525 2.47331 20.3525H21.5271C21.7818 20.3525 21.9892 20.1451 21.9892 19.8904C21.9892 19.6357 21.7818 19.4284 21.5271 19.4284ZM19.4837 18.5025V19.4284H13.3382V18.5025H19.4837ZM20.5615 16.5759V17.5783H12.2605V16.5759H20.5615ZM9.63346 15.4555C10.4443 15.3462 11.1774 14.9554 11.7236 14.345V14.4051C11.7236 14.6598 11.931 14.8672 12.1857 14.8672H12.8966V15.6518H11.7984C11.5437 15.6518 11.3363 15.8591 11.3363 16.1138V18.0404C11.3363 18.2951 11.5437 18.5025 11.7984 18.5025H12.4141V19.4284H9.63347L9.63346 15.4555ZM9.17138 10.6075C8.91668 10.6075 8.7093 10.8149 8.7093 11.0696V14.5202C8.16836 14.4203 7.67416 14.1417 7.30496 13.7281C7.52577 13.3198 7.64202 12.86 7.64202 12.3944V7.51665C8.0153 7.04581 8.57143 6.77651 9.17137 6.77651C10.2468 6.77651 11.1219 7.65159 11.1219 8.72704C11.1219 9.0752 11.0302 9.41577 10.8561 9.71194C10.7486 9.89478 10.779 10.1261 10.9297 10.2751C11.411 10.7494 11.6757 11.3827 11.6757 12.0585C11.6757 13.2573 10.8035 14.3 9.63343 14.5202V13.12L10.5138 12.2402C10.6937 12.0597 10.6937 11.7671 10.5138 11.5865C10.3327 11.4066 10.0406 11.4066 9.8595 11.5865L9.63343 11.8132V11.0696C9.63343 10.8149 9.42608 10.6075 9.17138 10.6075ZM12.6477 13.9431V12.9406H20.1742V13.9431H12.6477ZM19.0011 14.8672V15.6518H13.8208V14.8672H19.0011ZM5.289 15.1716C5.82994 15.0822 6.3259 14.8398 6.73131 14.4665C7.26232 15.0068 7.95981 15.3562 8.7093 15.4561V19.4284H5.28901L5.289 15.1716ZM4.82692 8.96596C4.57222 8.96596 4.36484 9.17334 4.36484 9.42804V14.2287C3.53123 14.019 2.93538 13.2613 2.93538 12.3944V6.46165C2.93538 5.41891 3.78417 4.5707 4.82691 4.5707C5.86965 4.5707 6.71786 5.41891 6.71786 6.46165V12.3944C6.71786 13.2613 6.12201 14.0184 5.28899 14.2287V9.42804C5.28899 9.17334 5.08162 8.96596 4.82692 8.96596Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default GardenViewIcon;
